module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "header": 'CLOSE DATE',
      "headerStyle": 'font-weight: bold; font-size: 24px;',
      "maxWidth": '505px'
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-nowrap items-center w-100 sub-header-title",
    staticStyle: {
      "color": "#000",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("\n      This feature will automatically close the RoundTable at the date and\n      time provided. It will also send an email reminder to students 24 hours\n      before closing time.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row no-margin center-xs courses-list",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "row center-xs col-xs-12 col-sm-12 col-md-12 col-lg-12 close-date-toogle-style"
  }, [_c('span', [_vm._v(" Close Date ")]), _vm._v(" "), _c('toggle-button', {
    staticClass: "ml2",
    attrs: {
      "sync": true,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.closeDate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.closeDate, "enabled", $$v)
      },
      expression: "closeDate.enabled"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row center-xs col-xs-12 col-sm-12 col-md-12 col-lg-12 datepicker-style mb3"
  }, [(_vm.closeDate.enabled) ? _c('flat-pickr', {
    staticClass: "roundtable-close-date-picker",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "config": _vm.config,
      "placeholder": "Select a date"
    },
    on: {
      "on-close": _vm.changedCloseDate
    },
    model: {
      value: (_vm.closeDate.date),
      callback: function($$v) {
        _vm.$set(_vm.closeDate, "date", $$v)
      },
      expression: "closeDate.date"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.closeDate.enabled) ? _c('div', {
    staticClass: "open-calendar",
    attrs: {
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.closeDate.enabled) ? _c('div', {
    staticClass: "mv2 row center-xs col-xs-12"
  }, [_c('pl-checkbox', {
    model: {
      value: (_vm.hard_close),
      callback: function($$v) {
        _vm.hard_close = $$v
      },
      expression: "hard_close"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "f5 mr3"
  }, [_vm._v("Hard close?\n        "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.top",
      value: (
        'Check this box to disable all student contributions after the close date.'
      ),
      expression: "\n            'Check this box to disable all student contributions after the close date.'\n          ",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "fas fa-info-circle",
    staticStyle: {
      "color": "#afadad"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row no-margin center-xs",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('pl-button', {
    staticClass: "close-cancel-button",
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      CLOSE\n    ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary save-button",
    nativeOn: {
      "click": function($event) {
        return _vm.saveCloseDate.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      SAVE\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0e80e613!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/closeDateModal.vue
// module id = 1173
// module chunks = 61